import { render, staticRenderFns } from "./ManagerCommissionsOverview.vue?vue&type=template&id=5f71b8e1&scoped=true&"
import script from "./ManagerCommissionsOverview.vue?vue&type=script&lang=js&"
export * from "./ManagerCommissionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ManagerCommissionsOverview.vue?vue&type=style&index=0&id=5f71b8e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71b8e1",
  null
  
)

export default component.exports